import * as React from 'react';
import { useState, useEffect } from 'react';
import { Document } from "shared/models/site/document"
import { DocumentHistory } from 'shared/models/api/models';
import { History as HistoryIcon, DescriptionOutlined as DescriptionIcon, VisibilityOutlined as VisibilityIcon } from '@mui/icons-material';
import { restoreDocument } from "shared/services/railDocumentsApi";
import { Table, ModalBody, Row, Col } from 'reactstrap';
import { getUserExistingRulebookMode } from '../../../../shared/store/applicationState';

export const DocumentHistoryView = (props: {
    document: Document,
    documentHistory: DocumentHistory[],
    onChangeValue: any
}) => {
    const [stateDocumentHistory, setStateDocumentHistory] = useState(props.documentHistory);
    const [displayedReleaseNote, setdisplayedReleaseNote] = useState(0);
    const [documentIdRestorePrompt, setDocumentIdRestorePrompt] = useState(0);
    const [displayRestoredResult, setDisplayRestoredResult] = useState(false);
    const [completing, setCompleting] = useState(false);
    const [restoredDocId, setRestoredDocId] = useState(0);
    const dateTimeFormat = new Intl.DateTimeFormat("en-AU", {});

    let mode: string | null;
    useEffect(() => {
        setStateDocumentHistory(props.documentHistory);
        mode = getUserExistingRulebookMode();
    });

    var n: number = 0;
    const rowClass = (): string => {
        return (n++ % 2 === 1) ? 'alternate-row' : '';
    };

    const toggleReleaseNote = (id: number) => {
        if (displayedReleaseNote === id) {
            setdisplayedReleaseNote(0);
        }
        else {
            setdisplayedReleaseNote(id);
        }
    };

    const releaseNoteClick = (event: any) => {
        event.stopPropagation();
    };

    const canRestore = (): boolean => {
        if (props.document.canEdit === false) {
            return false;
        }

        if (props.documentHistory[0].status !== 'Current') {
            return false;
        }

        return true;
    }

    const restoreConfirmPrompt = (id: number) => {
        setCompleting(false);
        setDocumentIdRestorePrompt(id);
    }

    const closeRestoreConfirmPrompt = () => {
        setDocumentIdRestorePrompt(0);
    }

    const restoreDocumentVersionById = async (id: number) => {
        setCompleting(true);
        const response = await restoreDocument(id);

        if (response.ok) {
            setRestoredDocId(await response.json());
            restoreDocumentVersionResult();
        }

        else {
            setDocumentIdRestorePrompt(0);
            console.log('Error restoring document - http status code ' + response.status);
            window.alert('Error restoring document');
        }

    }

    const restoreDocumentVersionResult = () => {
        setDocumentIdRestorePrompt(0);
        setDisplayRestoredResult(true);
    }

    const closeRestoreConfirmed = () => {
        setDisplayRestoredResult(false);
        if (typeof (restoredDocId) === 'number' && restoredDocId > 0) {
            props.onChangeValue(restoredDocId);
        }
    }

    const isRescinded = (history: DocumentHistory) => {
        return typeof (history.rescindedByDocumentId) === 'number';
    }

    const isRescinding = (history: DocumentHistory) => {
        return typeof (history.rescindsDocumentId) === 'number';
    }

    const isDeleted = (history: DocumentHistory) => {
        return history.statusId > 4;
    }

    return (
        <React.Fragment>
            <ModalBody className="pb-5 ml-4 document-info-body">
                <Row>
                    <Col><h3 className="header-row"><HistoryIcon className="body-icon" />Document history: {props.document.documentNumber} {props.document.title}</h3></Col>
                </Row>
                <Table>
                    <thead>
                        <tr>
                            <th>Version</th>
                            <th>Status</th>
                            <th>Change</th>
                            <th>Notes</th>
                            <th>User</th>
                            <th>Date of change</th>
                            {canRestore() === true &&
                                <th>Restore</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {stateDocumentHistory.map((history) => (
                            <tr className={rowClass()} key={history.id}>
                                <td>
                                    {history.version}
                                </td>
                                <td className={history.status == "Current" ? "current-version" : ""}>
                                    {history.status.replace(/([A-Z])/g, ' $1').trim()}
                                </td>
                                <td>
                                    {(isDeleted(history) === false && isRescinded(history) === false && isRescinding(history) === false) &&
                                        <a href={`/pdf/view/${mode}/` + history.id} target="_blank" className={"history-button-link"}>
                                            {history.action.replace(/([A-Z])/g, ' $1').trim()}
                                        </a>
                                    }
                                    {isRescinded(history) === true &&
                                        <>
                                        Recinded by <a href={`/pdf/view/${mode}/` + history.rescindedByDocumentId} target="_blank" className={"history-button-link"}>{history.rescindedByDocumentNumber}</a>
                                        </>
                                    }
                                    {isRescinding(history) === true &&
                                        <>
                                        Rescinded <a href={`/pdf/view/${mode}/` + history.rescindsDocumentId} target="_blank" className={"history-button-link"}>{history.rescindsDocumentNumber}</a>
                                        </>
                                    }
                                    {(isDeleted(history) === true) &&
                                        <>
                                            {history.action.replace(/([A-Z])/g, ' $1').trim()}
                                        </>
                                    }
                                </td>
                                <td>
                                    <div className={displayedReleaseNote === history.id ? 'release-note-selected' : ''} onClick={() => toggleReleaseNote(history.id)}>
                                        <div className="history-button-outline">
                                            <div className="history-button-content"><DescriptionIcon className={"button-icon"} />
                                                <div className="history-button-text">{displayedReleaseNote === history.id ? 'Hide' : 'Read'}</div>
                                            </div>
                                        </div>
                                        <div className="release-note" onClick={releaseNoteClick}>{history.releaseNotes}</div>
                                    </div>
                                </td>
                                <td>
                                    {history.userName}
                                </td>
                                <td> {history.d2ChangeDate ?
                                        <>
                                        {dateTimeFormat.format(new Date(history.d2ChangeDate))} {new Date(history.d2ChangeDate).toLocaleTimeString('en-GB')} {"(D2)"}
                                        </>
                                        :
                                        <>
                                            {dateTimeFormat.format(new Date(history.changeDate))} {new Date(history.changeDate).toLocaleTimeString('en-GB')}
                                        </>
                                      }
                                </td>
                                {canRestore() === true &&
                                    <td>
                                        {history.statusId === 1 &&
                                            <div className="history-button-content current-version"></div>
                                        }
                                        {history.statusId === 2 &&
                                            <div className="history-button-outline" onClick={() => restoreConfirmPrompt(history.id)}>
                                                <div className="history-button-content">
                                                    <HistoryIcon className={"button-icon"} />
                                                    <div className="history-button-text">Restore</div>
                                                </div>
                                            </div>
                                        }
                                        {history.statusId >= 3 &&
                                            <div className="history-button-content">{history.status}</div>
                                        }
                                    </td>
                                }
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </ModalBody>

            {documentIdRestorePrompt !== 0 &&
                <React.Fragment>
                    <div className="modal fade show" style={{ display: 'block' }}>
                        <div className="modal-dialog document-info-modal">
                            <div className="pop-up-modal-content">
                                <div className="pop-up-style">
                                    <div className="prompt-text">Are you sure you want to restore this previous version of this file?</div>
                                    {completing
                                        ?
                                        <React.Fragment>
                                            <div className="history-button-outline disabled">
                                                <div className="history-button-content">
                                                    <div className="history-button-text">Restoring</div>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                        :
                                        <React.Fragment>
                                            <div className="history-button-outline" onClick={closeRestoreConfirmPrompt}>
                                                <div className="history-button-content">
                                                    <div className="history-button-text">Cancel</div>
                                                </div>
                                            </div>
                                            <div className="confirm history-button-outline" onClick={() => restoreDocumentVersionById(documentIdRestorePrompt)}>
                                                <div className="history-button-content">
                                                    <div className="history-button-text">Restore file</div>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </React.Fragment>
            }

            {displayRestoredResult === true &&
                <React.Fragment>
                    <div className="modal fade show" style={{ display: 'block' }}>
                        <div className="modal-dialog document-info-modal">
                            <div className="pop-up-modal-content">
                                <div className="pop-up-style">
                                    <div className="prompt-text">The previous version of this file has been restored.</div>
                                    <div className="confirm history-button-outline" onClick={closeRestoreConfirmed}>
                                        <div className="history-button-content">
                                            <div className="history-button-text">OK</div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </React.Fragment>
            }

        </React.Fragment>
    );
}
